import { compose } from "../../utils/compose";
import { ApolloClient, useApolloClient } from "@apollo/client";
import { UseStateSearch, useStateSearch } from "../../hooks/useStateSearch";
import {
  usePlaylistPicker,
  UsePlaylistPicker,
} from "./hooks/usePlaylistPicker";
import { useTagSelection, UseTagSelection } from "../TagList/useTagSelection";

export interface ApolloProps
  extends UseStateSearch,
    UsePlaylistPicker,
    UseTagSelection {
  playlistData: UsePlaylistPicker;
  client: ApolloClient<object>;
  excludeShare?: boolean;
}

export const withData = compose(
  (Component) => (props: any) => {
    return (
      <Component {...props} client={useApolloClient()} {...useStateSearch()} />
    );
  },
  (Component) => (props) => {
    const {
      onClickTag,
      onSetelectTags,
      selectedTagForQuery,
      onClearTags,
      hasSelectedTags,
      selectedTags,
    } = useTagSelection();

    const playlistData = usePlaylistPicker(
      props.excludeShare,
      props.spaceId,
      selectedTagForQuery,
    );

    return (
      <Component
        {...props}
        onClickTag={onClickTag}
        onSetelectTags={onSetelectTags}
        selectedTagForQuery={selectedTagForQuery}
        onClearTags={onClearTags}
        hasSelectedTags={hasSelectedTags}
        selectedTags={selectedTags}
        playlistData={playlistData}
      />
    );
  },
);
